import React, { FC } from "react";
import { getProfileURL } from "../../../../../utils/profile-url";
import { AvatarStyle } from "../../../style";
import { ChatListType } from "../../../types";
import { ConversationTypeEnum } from "../../../types/enums";

interface Props {
  chat?: ChatListType;
}

const conversationList = ["group", "channel"];

const Avatar: FC<Props> = (props) => {
  return (
    <div
      style={
        props?.chat?.user?.photoFile
          ? {
              backgroundImage: "url(/assets/images/avatar-bg-1.png)",
              width: "50px",
              height: "50px",
            }
          : {
              width: "50px",
              height: "50px",
            }
      }
      id="person-info"
      className="main-avatar"
    >
      {props.chat?.user?.photoFile && (
        <AvatarStyle
          src={
            conversationList.includes(props.chat.type!)
              ? props.chat.user.photoFile
              : getProfileURL(
                  props?.chat.user.id ?? "",
                  props.chat.user.photoFile!
                )
          }
        />
      )}
    </div>
  );
};
export default Avatar;
